<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Annotation Import Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.createdDate"
                label="Created Date"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-combobox
                small-chips
                deletable-chips
                v-validate="'required'"
                data-vv-name="annotator"
                :error-messages="errors.collect('annotator')"
                v-model="item.annotator"
                item-text="text"
                item-value="value"
                :items="annotators"
                label="Annotator">
                </v-combobox>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <vue2-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :use-custom-dropzone-options="true"
                v-on:vdropzone-success="dropzone_success" v-on:vdropzone-error="dropzone_error"></vue2-dropzone>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="headline">Delete dataset</v-card-title>
      <v-card-text>
        The process migh take some time! Please, follow the status.
      </v-card-text>
      <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
        <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
          Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
          Delete
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapActions } from 'vuex'

export default {
  name: 'annotation-task-item',
  components: {
    vue2Dropzone
  },
  props: {
    annotationWorkId: {
      type: String,
      required: true,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    this.axios.get(`/annotators`)
      .then(r => {
        this.annotators = r.data.filter((a) => {
          return a.is_active
        }).map((a) => {
          return {
            value: a.id,
            text: `${a.first_name} ${a.last_name}`,
            email: a.email
          }
        })
      })
      .catch(e => {
        this.handleAxiosError(e)
      })
  },
  data () {
    return {
      item: {
        annotator: ''
      },
      dropzoneOptions: {
        url: new URL(`annotation-works/${this.annotationWorkId}/annotation-tasks/upload`, this.axios.defaults.baseURL).href,
        thumbnailWidth: 150,
        acceptedFiles: '.xlsx',
        maxFilesize: 100,
        maxFiles: 1,
        headers: { 'Authorization': `${this.$auth.token()}` },
        addRemoveLinks: false
      },
      uploaded_filename: null,
      file_size: 0,
      saveLoading: false,
      annotators: []
    }
  },
  computed: {

  },
  methods: {
    cancel () {
      this.$router.push({name: 'annotationWorkEdit', params: { id: this.annotationWorkId, stepProp: 1 }})
    },
    dropzone_success (file, response) {
      this.uploaded_filename = response.filename
      this.file_size = file.size / 1000
      this.setSnack({
        message: 'Your file has been uploaded successfully! Click save to process it.',
        type: 'success',
        timeout: 6000
      })
    },
    dropzone_error (file, message, xhr) {
      var m = null
      this.$refs.myVueDropzone.removeAllFiles()
      this.uploaded_filename = null
      this.file_size = 0
      if (message.error_description != null) {
        m = message.error_description
      } else {
        m = message
      }
      this.setSnack({
        message: m,
        type: 'error',
        timeout: 4000
      })
    },
    save () {
      if (this.uploaded_filename == null) {
        this.setSnack({
          message: ' Please upload the annotation file.',
          type: 'error'
        })
      } else {
        this.saveLoading = false
        let itemToSave = {
          annotator: Array.isArray(this.item.annotator) ? this.item.annotator.map(a => a.value) : [this.item.annotator.value],
          filename: this.uploaded_filename
        }

        this.$refs.myVueDropzone.removeAllFiles()
        this.$router.push({name: 'annotationWorkEdit', params: { id: this.annotationWorkId, stepProp: 1 }})

        this.axios.post(`/annotation-works/${this.annotationWorkId}/annotation-tasks/import`, itemToSave)
          .then(response => {
            this.setSnack({
              message: `File size is ${this.file_size} MB. It may take a while to process it!`,
              type: 'success',
              timeout: 6000
            })
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.$refs.myVueDropzone.removeAllFiles()
            this.saveLoading = false
            this.uploaded_filename = null
            this.file_size = 0
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
